// ============================================
// LAYOUT COMPONENT
// ============================================

import type { ReactNode } from 'react';

import styles from './Layout.module.css';
import { APP_NAME } from '../../constants';
import logo from '../../assets/favicon.ico'

interface LayoutProps {
  children: ReactNode;
  showHeader?: boolean;
  maxWidth?: 'sm' | 'md' | 'lg';
}

export function Layout({ 
  children, 
  showHeader = true, 
  maxWidth = 'md' 
}: LayoutProps) {
  const year = new Date().getFullYear();
  return (
    <div className={styles.layout}>
      {showHeader && (
        <header className={styles.header}>
          <div className={styles.logo}>
            <img src={logo} />
            <span>{APP_NAME}</span>
          </div>
        </header>
      )}
      <main className={`${styles.main} ${styles[`max-${maxWidth}`]}`}>
        {children}
      </main>
      <footer className={styles.footer}>
        <p>© {year} FL Smartech Private Limited. All rights reserved.</p>
      </footer>
    </div>
  );
}
